module.exports = __webpack_public_path__ + "static/media/hospital-week-hero.6b7772f5.jpg";